import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { Box } from "@mui/material";
import DialButton from "../../../Buttons/DialButton/DialButton";
import EmailButton from "../../../Buttons/EmailButton/EmailButton";
import { formatPhoneNumber } from "../../../../utils/formatHelpers";
import { SecurityService } from "../../../../services/SecurityService";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function ContactConnectCapstoneCell(cell) {
  const { instance } = useMsal();
  const contact = nullCheck(cell, null, "row", "original");

  useEffect(() => {
    if (contact?.name && !(contact?.email || contact?.phone)) {
      const capstoneContacts = JSON.parse(localStorage.getItem("capstoneContacts")) || [];
      let foundContact = capstoneContacts && capstoneContacts.length > 0 ? capstoneContacts.find(o => o.id === contact.name) : null;
      if (foundContact) {
        contact.phone = formatPhoneNumber(foundContact.phone);
        contact.email = foundContact.emailAddress;
      } else {
        SecurityService.GetUserByIdMcLeod(instance, contact.name).then(resMc => {
          contact.phone = formatPhoneNumber(resMc?.phone);
          contact.email = resMc?.emailAddress;
          capstoneContacts.push(resMc);
          localStorage.setItem("capstoneContacts", JSON.stringify(capstoneContacts));
        }).catch(error => {
          console.log(error);
        });
      }
    }

  }, []);

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ marginRight: "4px" }}>
        <DialButton
          number={contact?.phone}
          icon="phone"
          disabled={!contact?.phone}
          color="blue"
        />
      </Box>
      <EmailButton email={contact?.email} disabled={!contact?.email} color="blue" />
    </Box>
  );
}